import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a36e93dc")

_pushScopeId("data-v-a36e93dc")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("fieldset", {
    id: _ctx.id,
    class: _ctx.layoutClasses
  }, [
    (_ctx.label)
      ? (_openBlock(), _createBlock("legend", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createBlock("div", {
        key: option.text
      }, [
        _createVNode("label", {
          style: {"min-width":"8rem"},
          for: _ctx.id + index
        }, [
          _createVNode("input", {
            id: _ctx.id + index,
            name: _ctx.id,
            type: "radio",
            value: option.value,
            checked: option.value === _ctx.modelValue,
            class: _ctx.inputClass,
            disabled: _ctx.disabled,
            required: _ctx.required,
            onChange: ($event: any) => (_ctx.updateValue(option.value))
          }, null, 42, ["id", "name", "value", "checked", "disabled", "required", "onChange"]),
          _createVNode("span", null, [
            _renderSlot(_ctx.$slots, "default", { option: option })
          ]),
          (option.value === _ctx.modelValue)
            ? _renderSlot(_ctx.$slots, option.value, { key: 0 })
            : _createCommentVNode("", true)
        ], 8, ["for"])
      ]))
    }), 128))
  ], 10, ["id"]))
})